import React from "react";
import arrow from "../../assets/icons/arrowBlack.svg";
import { Link } from "react-scroll";
function ButtonPrimary(props: any) {
  const { text, target } = props;
  return (
    <div>
      <button className="bg-theme-primary rounded-pill border border-0 py-2 px-3 poppins-medium text-transform-uppercase font-13 letter-spacing-2 text-black arrow-effect ">
        <Link
          to={target}
          spy={true}
          smooth={true}
          offset={-70}
          duration={100}
          className="text-decoration-none text-black"
          style={{ cursor: "pointer" }}
        >
          {text}
          <img className="ms-2" src={arrow} alt="arrow" />
        </Link>
      </button>
    </div>
  );
}

export default ButtonPrimary;
